export class Acquisitions_Util {
  static sortByDate(acqnDashboardDetails) {

    //first split up properties by dates (check required submission date first, then acqn date)
    let currentAndFutureDates = [];
    let pastDates = [];
    let noDates = []
    acqnDashboardDetails.forEach((property) => {
      if (property.reqdSubmtDt == null && property.aqsnDt == null) {
        noDates.push(property);
      }
      else {
        const date = property.reqdSubmtDt != null ? new Date(property.reqdSubmtDt) : new Date(property.aqsnDt);
        if (date.toISOString().split('T')[0] >= new Date().toISOString().split('T')[0]) {
          currentAndFutureDates.push(property);
        }
        else {
          pastDates.push(property);
        }
      }
    });

    //sort ascending for future dates + today
    currentAndFutureDates.sort((a, b) => {
      const dateA = a.reqdSubmtDt != null ? new Date(a.reqdSubmtDt) : new Date(a.aqsnDt);
      const dateB = b.reqdSubmtDt != null ? new Date(b.reqdSubmtDt) : new Date(b.aqsnDt);

      return dateA.getTime() - dateB.getTime();
    });

    //sort descending for past dates
    pastDates.sort((a, b) => {
      const dateA = a.reqdSubmtDt != null ? new Date(a.reqdSubmtDt) : new Date(a.aqsnDt);
      const dateB = b.reqdSubmtDt != null ? new Date(b.reqdSubmtDt) : new Date(b.aqsnDt);

      return dateB.getTime() - dateA.getTime();
    });

    //concat all 3 arrays
    let finalArray = [];
    finalArray = finalArray.concat(currentAndFutureDates);
    finalArray = finalArray.concat(pastDates);
    finalArray = finalArray.concat(noDates);
    return finalArray;
  };
}